import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById('precio');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="min-h-screen flex items-center justify-center text-center px-6 pt-[120px] pb-20 relative overflow-hidden bg-[radial-gradient(ellipse_at_top,#1a0a00_0%,#0A0A0A_60%)]" data-id="element-133">
      {/* Subtle orange glow at top */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,rgba(255,107,0,0.15)_0%,transparent_60%)] pointer-events-none" data-id="element-134" />

      <div className="relative z-10 w-full max-w-5xl mx-auto" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-136">
          <div className="inline-block bg-[rgba(255,107,0,0.15)] border border-[rgba(255,107,0,0.4)] text-orange px-5 py-2 rounded-full text-[13px] font-semibold mb-7 tracking-wide uppercase" data-id="element-137">
            ⚡ Sistema Probado • Herramientas 100% Gratuitas
          </div>

          <h1 className="text-[clamp(36px,7vw,72px)] font-black leading-[1.1] mb-6 max-w-[900px] mx-auto text-white" data-id="element-138">
            Produce <span className="text-orange relative" data-id="element-139">30 Días</span> de
            Contenido
            <br data-id="element-140" />
            en Solo <span className="text-gold" data-id="element-141">4 Horas</span>
          </h1>

          <p className="text-[clamp(16px,2.5vw,22px)] text-[#CCCCCC] max-w-[650px] mx-auto mb-10 leading-[1.7]" data-id="element-142">
            El sistema completo para emprendedores que quieren dejar de luchar
            contra la pantalla en blanco — y empezar a fabricar contenido
            profesional con IA gratuita.
          </p>

          <div className="flex flex-col items-center gap-4 mb-16" data-id="element-143">
            <p className="text-[14px] text-red-400 font-semibold mb-1 animate-pulse" data-id="element-144">
              🔥 Oferta especial por tiempo limitado — Precio sube pronto
            </p>
            <a href="#precio" onClick={scrollToPricing} className="bg-gradient-to-br from-orange to-[#FF8C00] text-white px-12 py-[18px] rounded-xl font-extrabold text-lg no-underline inline-block transition-all duration-300 shadow-[0_8px_32px_rgba(255,107,0,0.4)] hover:-translate-y-[3px] hover:shadow-[0_12px_40px_rgba(255,107,0,0.6)] w-full max-w-[420px] text-center animate-pulse" data-id="element-145">
              🏭 Quiero Mi Fábrica de Contenido →
            </a>
            <p className="text-[13px] text-gray-400" data-id="element-146">
              <span className="text-green font-semibold" data-id="element-147">
                ✓ Descarga instantánea
              </span>{' '}
              &nbsp;•&nbsp; Sin suscripción &nbsp;•&nbsp; Acceso de por vida
            </p>
          </div>

          <div className="flex justify-center gap-10 flex-wrap mb-16" data-id="element-148">
            <div className="text-center" data-id="element-149">
              <span className="text-[28px] font-black text-orange block" data-id="element-150">
                30
              </span>
              <span className="text-[13px] text-gray-400" data-id="element-151">
                Días de contenido
              </span>
            </div>
            <div className="text-center" data-id="element-152">
              <span className="text-[28px] font-black text-orange block" data-id="element-153">
                4h
              </span>
              <span className="text-[13px] text-gray-400" data-id="element-154">
                Una sola vez por mes
              </span>
            </div>
            <div className="text-center" data-id="element-155">
              <span className="text-[28px] font-black text-orange block" data-id="element-156">
                50
              </span>
              <span className="text-[13px] text-gray-400" data-id="element-157">
                Prompts maestros
              </span>
            </div>
            <div className="text-center" data-id="element-158">
              <span className="text-[28px] font-black text-orange block" data-id="element-159">
                $0
              </span>
              <span className="text-[13px] text-gray-400" data-id="element-160">En herramientas</span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative max-w-[400px] mx-auto" data-id="element-161">
          <img src="https://cdn.magicpatterns.com/uploads/bbMzAFZBn3Wuv2cbo2ZMYU/ChatGPT_Image_Mar_4,_2026,_11_50_59_PM.png" alt="Fábrica de Contenido con IA — Gean Ortiz" className="w-full rounded-2xl shadow-[0_24px_80px_rgba(255,107,0,0.3)] object-cover" data-id="element-162" />
          <div className="absolute -bottom-4 -right-4 bg-gold text-dark px-5 py-3 rounded-xl font-black text-sm text-center shadow-[0_8px_24px_rgba(255,215,0,0.4)]" data-id="element-163">
            🎁 50 Prompts
            <br data-id="element-164" />
            Incluidos
          </div>
        </motion.div>
      </div>
    </section>;
}